import * as marietta from '../../..';
import { SVGSprite } from '../../flash/display';

export default class SiteAltitudeLineText {
    _centerPoint: marietta.core.Point;

    get centerPoint() { return this._centerPoint; }

    set centerPoint(_dot) {
      this._centerPoint = _dot;
      this.updateTransforms();
    }

    _rotation: number;

    get rotation() { return this._rotation; }

    set rotation(_rot) {
      this._rotation = _rot;
      this.updateTransforms();
    }

    _distance: number;

    get distance() { return this._distance; }

    set distance(_dist) {
      this._distance = _dist;
      this.updateTransforms();
    }

    public spt: SVGSprite;

    /**
     * コンストラクタ
     * */
    constructor(targetNode: Element, id: string) {
      // ラインの作成
      const viewObj: Element = document.createElementNS('http://www.w3.org/2000/svg', 'text');
      viewObj.setAttribute('id', `altitude_line_text_${id}`);
      viewObj.setAttribute('fill', '#0000FF');
      viewObj.textContent = '0mm';
      this.spt = new SVGSprite(viewObj);
      targetNode.appendChild(viewObj);
      this.show();
    }

    /**
     * Translateのアップデート
     */
    updateTransforms() {
      if (this.centerPoint === undefined || this.centerPoint === null || this.rotation === undefined || this.rotation === null) return;
      const num = marietta.webcad.util.WebCADUtil.sepThreeDigit(Math.round(this.distance));
      this.viewObj.textContent = `${num}mm`;
      // const bound = this.viewObj.getBoundingClientRect();
      this.spt.x = this.centerPoint.x;
      this.spt.y = this.centerPoint.y;
      this.spt.rotation = this.rotation;
      this.spt.update();

      this.updateTranslate();
    }

    /**
     * HTMLElementの取得
     */
    public get viewObj(): HTMLElement {
      return this.spt.element;
    }

    /**
     * 表示ON
     */
    show() {
      this.spt.element.style.visibility = 'visible';
    }

    /**
     * 表示ON
     */
    hide() {
      this.spt.element.style.visibility = 'hidden';
    }

    /**
     * update translate for text attributes
     */
    public updateTranslate(): void {
      if (this.centerPoint === undefined || this.centerPoint === null || this.rotation === undefined || this.rotation === null) return;
      const root: SVGSprite = marietta.webcad.WebCADGlobal.layerGroup.spt;
      const sc: number = 1 / root.scaleX;
      /* if (marietta.webcad.WebCADGlobal.userAgentManager.isMobile || marietta.webcad.WebCADGlobal.userAgentManager.isTablet) {
            sc *= 2;
        } */
      const bound = this.viewObj.getBoundingClientRect();
      const x = (this.centerPoint.x - (bound.width / 2) * sc);
      const y = (this.centerPoint.y + (bound.height / 2) * sc);
      const transformMatrix = `matrix(${sc},0,0,${sc},${x},${y})`;
      this.spt.element.setAttribute('transform', transformMatrix);
    }
}
